import React from "react";
import { SvgIcon } from "@mui/material";
import { SvgIconsProps } from "~/common";

export const Check = (props: SvgIconsProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M13.724 19.6093C13.984 19.8693 14.3254 19.9999 14.6667 19.9999C15.008 19.9999 15.3494 19.8693 15.6094 19.6093L20.9427 14.2759C21.464 13.7546 21.464 12.9119 20.9427 12.3906C20.4214 11.8693 19.5787 11.8693 19.0574 12.3906L14.6667 16.7813L12.9427 15.0573C12.4214 14.5359 11.5787 14.5359 11.0574 15.0573C10.536 15.5786 10.536 16.4213 11.0574 16.9426L13.724 19.6093Z"
        fill="#00382A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33337 15.9999C1.33337 24.0866 7.91337 30.6666 16 30.6666C24.0867 30.6666 30.6667 24.0866 30.6667 15.9999C30.6667 7.91325 24.0867 1.33325 16 1.33325C7.91337 1.33325 1.33337 7.91325 1.33337 15.9999ZM4.00004 15.9999C4.00004 9.38392 9.38404 3.99992 16 3.99992C22.6174 3.99992 28 9.38392 28 15.9999C28 22.6173 22.6174 27.9999 16 27.9999C9.38404 27.9999 4.00004 22.6173 4.00004 15.9999Z"
        fill="#00382A"
      />
    </SvgIcon>
  );
};
